import { ADD_ENTITIES } from '../../actions';

const initialState = {};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case ADD_ENTITIES:
      return {
        ...state,
        ...action.payload.products
      };

    default: 
      return state
  }
};


// WEBPACK FOOTER //
// ./src/redux/modules/products/index.js